/**
 * Object tree over the default categories for displaying
 * products in the gallery
 *
 * Modelspec. Ett frågetecken efter propertyn betyder att den inte behövs.
 *
 * 	- name: Namnet på kategorin
 * 	- image?: filnamn på kategoribild
 * 	- description?: Beskrivning som visas i kategorin
 * 	- contents?: Subkategorier
 */
 export const defaultCategories = [
  {
    name: "Plåtprodukter",
    label: {
      sw: "Plåtprodukter",
      en: "Sheet metal products",
      nor: "Plateprodukter",
      da: "Metalpladeprodukter",
      fin: "Peltituotteet",
      ru: "Изделия из листового металла",
      gr: "Blechprodukte"
    },
    image: "categories/fasadbleck/fonsterbleck/fonsterbleck.jpg",
    description: {
      sw: "Välj plåtprodukt i produktbiblioteket",
      en: "Select sheet metal product in the product library",
      nor: "Velg metallplater i produktbiblioteket",
      da: "Vælg metalpladeprodukt i produktbiblioteket",
      fin: "Valitse ohutlevytuote tuotekirjastosta",
      ru: "Выберите продукт из листового металла в библиотеке продуктов",
      gr: "Blechprodukt in der Produktbibliothek auswählen"
    },
    contents: [
      {
        name: "Fasadbleck",
        label: {
          sw: "Fasadbleck",
          en: "Facade sheets",
          nor: "Fasadeark",
          da: "Facadeark",
          fin: "Julkisivulevy",
          ru: "Фасадный лист",
          gr: "Fassadenblech"
        },
        image: "categories/fasadbleck/fasadbleck.jpg",
        description: {
          sw: "Här finns plåtbleck som monteras på fasader. Till exempel fönsterbleck och sockelbleck.",
          en: "Here are sheet metal sheets that are mounted on facades. For example, window panes and plinth panes.",
          nor: "Her er metallplater som er montert på fasader. For eksempel vindusruter og sokkelruter.",
          da: "Her er metalplader, der er monteret på facader. For eksempel vinduesruder og sokkelruder.",
          fin: "Tässä ovat metallilevyt, jotka on asennettu julkisivuihin. Esimerkiksi ikkuna- ja sokkeliruudut.",
          ru: "Вот листы из листового металла, которые крепятся на фасады. Например, оконные стекла и цоколи.",
          gr: "Hier handelt es sich um Bleche, die an Fassaden montiert werden. Zum Beispiel Fensterscheiben und Sockelscheiben."
        },
        contents: [
          {
            name: "Fönsterbleck",
            label: {
              sw: "Fönsterbleck",
              en: "Windowsill",
              nor: "Vinduskarm",
              da: "Vindueskarmen",
              fin: "Ikkunaluukku",
              ru: "Подоконник",
              gr: "Fensterbrett"
            },
            image: "categories/fasadbleck/fonsterbleck/fonsterbleck.jpg",
            description: {
              sw: "Fönsterbleck finns under fönster och kallas även för underbleck.",
              en: "Here are sheet metal sheets that are mounted on facades. For example, window panes and plinth panes.",
              nor: "Vindusruter er plassert under vinduer og kalles også underruter.",
              da: "Vinduesruder er placeret under vinduer og kaldes også underruder.",
              fin: "Ikkunaruudut sijaitsevat ikkunoiden alla ja niitä kutsutaan myös aliruutuiksi.",
              ru: "Оконные стекла расположены под окнами и также называются субпанелями.",
              gr: "Fensterbereiche befinden sich unter Fenstern und werden auch als Unterbereiche bezeichnet."
            },
            contents: [],
          },
          {
            name: "Droppbleck",
            label: {
              sw: "Droppbleck",
              en: "Drip tin",
              nor: "Dryppform",
              da: "Dryppeform",
              fin: "Tippua tinaa",
              ru: "Жидкость для капель",
              gr: "Droppbleck"
            },
            image: "categories/fasadbleck/droppbleck/droppbleck.jpg",
            description: {
              sw: "Droppbleck finns ovanför fönster och kallas även för överbleck.",
              en: "Drip sheets are located above windows and are also called overview sheets.",
              nor: "Dryppark er plassert over vinduer og kalles også oversiktsark.",
              da: "Dryppeark er placeret over vinduer og kaldes også oversigtsark.",
              fin: "Tiputusarkit sijaitsevat ikkunoiden yläpuolella, ja niitä kutsutaan myös yleiskatsauslehdiksi.",
              ru: "Капельные листы расположены над окнами и также называются обзорными листами.",
              gr: "Tropfbleche befinden sich über Fenstern und werden auch Übersichtsblätter genannt."
            },
            contents: [],
          },
          {
            name: "Tröskelbleck",
            label: {
              sw: "Tröskelbleck",
              en: "Threshold sheet metal",
              nor: "Terskelplate",
              da: "Tærskelplade",
              fin: "Kynnyspelti",
              ru: "Порог из листового металла",
              gr: "Schwellenblech"
            },
            image:
              "categories/fasadbleck/troskelbleck/troskelbleck_gavel_enkel.jpg",
            description: {
              sw: "Tröskelbleck finns vid dörrar och entréer, och är tillverkat i syrafast rostfri plåt.",
              en: "Threshold sheets are available at doors and entrances, and are made of acid-resistant stainless steel.",
              nor: "Terskelark er tilgjengelig ved dører og innganger, og er laget av syrefast rustfritt stål.",
              da: "Tærskelark fås ved døre og indgange og er lavet af syrefast rustfrit stål.",
              fin: "Kynnysarkkeja on saatavana ovista ja sisäänkäynnistä, ja ne on valmistettu haponkestävästä ruostumattomasta teräksestä.",
              ru: "Листы порога доступны на дверях и входах и изготовлены из кислотостойкой нержавеющей стали.",
              gr: "An Türen und Eingängen sind Schwellenbleche aus säurebeständigem Edelstahl erhältlich."
            },
          },
          {
            name: "Fönstersmygar",
            label: {
              sw: "Fönstersmygar",
              en: "Window sneakers",
              nor: "Vindussneakers",
              da: "Vinduesneakers",
              fin: "Ikkunakengät",
              ru: "Кроссовки Window",
              gr: "Fenster Turnschuhe"
            },
            image: "categories/fasadbleck/fonstersmyg/fonstersmyg.jpg",
            description: {
              sw: "Fönstersmygar finns på sidorna av ett fönster, och ibland ovanför ett fönster.",
              en: "Window snakes are found on the sides of a window, and sometimes above a window.",
              nor: "Vinduskarmer finnes på sidene av et vindu, og noen ganger over et vindu.",
              da: "Vindueskarme findes på siderne af et vindue og undertiden over et vindue.",
              fin: "Ikkunalaudat löytyvät ikkunan sivuilta ja joskus ikkunan yläpuolelta.",
              ru: "Подоконники находятся по бокам окна, а иногда и над окном.",
              gr: "Fensterschlangen werden an den Seiten eines Fensters und manchmal über einem Fenster gefunden."
            },
          },
          {
            name: "Sockelbleck",
            label: {
              sw: "Sockelbleck",
              en: "Base plinth",
              nor: "Sokkel",
              da: "Sokkel",
              fin: "Pohjallinen",
              ru: "Цоколь",
              gr: "Sockelleiste"
            },
            image: "categories/fasadbleck/sockelbleck/sockelbleck.jpg",
            description: {
              sw: "Sockelbleck finns längst ner på fasader och balkonger där olika material möter varandra.",
              en: "Plinth sheets are found at the bottom of facades and balconies where different materials meet.",
              nor: "Sokkelark finnes nederst på fasader og balkonger der forskjellige materialer møtes.",
              da: "Sokkelark findes i bunden af ​​facader og altaner, hvor forskellige materialer mødes.",
              fin: "Sokkelilevyt löytyvät julkisivujen ja parvekkeiden alaosasta, joissa eri materiaalit kohtaavat.",
              ru: "Листы цоколя находятся внизу фасадов и балконов, где встречаются разные материалы.",
              gr: "Sockelleisten finden sich an der Unterseite von Fassaden und Balkonen, wo unterschiedliche Materialien aufeinandertreffen."
            },
          },
          {
            name: "Fästbleck",
            label: {
              sw: "Fästbleck",
              en: "Mounting plate",
              nor: "Monteringsplate",
              da: "Monteringsplade",
              fin: "Asennuslevy",
              ru: "Монтажная пластина",
              gr: "Montageplatte"
            },
            image: "categories/fasadbleck/fastbleck/fastbleck_falsat_1.jpg",
            description: {
              sw: "Fästbleck monteras under de flesta bleck, till exempel under ett fönsterbleck.",
              en: "Mounting plates are mounted under most plates, for example under a window plate.",
              nor: "Monteringsplater er montert under de fleste plater, for eksempel under en vindusplate.",
              da: "Monteringsplader monteres under de fleste plader, f.eks. Under en vinduesplade.",
              fin: "Asennuslevyt asennetaan useimpien levyjen alle, esimerkiksi ikkunalevyn alle.",
              ru: "Монтажные пластины монтируются под большинством пластин, например, под оконной пластиной.",
              gr: "Montageplatten werden unter den meisten Platten montiert, beispielsweise unter einer Fensterplatte."
            },
            contents: [
              {
                name: "Fästbleck falsat 1",
                label: {
                  sw: "Fästbleck falsat 1",
                  en: "Mounting plate folded 1",
                  nor: "Monteringsplate brettet 1",
                  da: "Monteringsplade foldet 1",
                  fin: "Asennuslevy taitettuna 1",
                  ru: "Монтажная пластина в сложенном виде 1",
                  gr: "Montageplatte gefaltet 1"
                },
                image: "categories/fasadbleck/fastbleck/fastbleck_falsat_1.jpg",
              },
              {
                name: "Fästbleck falsat 2",
                label: {
                  sw: "Fästbleck falsat 2",
                  en: "Mounting plate folded 2",
                  nor: "Monteringsplate brettet 2",
                  da: "Monteringsplade foldet 2",
                  fin: "Asennuslevy taitettuna 2",
                  ru: "Монтажная пластина в сложенном виде 2",
                  gr: "Montageplatte gefaltet 2"
                },
                image: "categories/fasadbleck/fastbleck/fastbleck_falsat_2.jpg",
              },
              {
                name: "Fästbleck popnit 1",
                label: {
                  sw: "Fästbleck popnit 1",
                  en: "Mounting plate pop rivets 1",
                  nor: "Monteringsplate popnagler 1",
                  da: "Monteringsplade popnitter 1",
                  fin: "Fästbleck popnit 1",
                  ru: "Монтажная пластина заклепками 1",
                  gr: "Montageplatte Popnit 1"
                },
                image: "categories/fasadbleck/fastbleck/fastbleck_popnit_1.jpg",
              },
              {
                name: "Fästbleck popnit 2",
                label: {
                  sw: "Fästbleck popnit 2",
                  en: "Mounting plate popnit 2",
                  nor: "Monteringsplate popnit 2",
                  da: "Monteringsplade popnit 2",
                  fin: "Asennuslevyn popnit 2",
                  ru: "Монтажная пластина попнит 2",
                  gr: "Montageplatte Popnit 2"
                },
                image: "categories/fasadbleck/fastbleck/fastbleck_popnit_2.jpg",
              },
              {
                name: "Driv- vattenbleck",
                label: {
                  sw: "Driv- vattenbleck",
                  en: "Drift water plate",
                  nor: "Drivvann plate",
                  da: "Drevvandplade",
                  fin: "Drift vesilevy",
                  ru: "Пластина для дрейфующей воды",
                  gr: "Treibwasserplatte"
                },
                image: "categories/fasadbleck/fastbleck/driv_vattenbleck.jpg",
              },
            ],
          },
          {
            name: "Hörnbeslag",
            label: {
              sw: "Hörnbeslag",
              en: "Corner fittings",
              nor: "Hjørneinnredning",
              da: "Hjørneindretning",
              fin: "Kulmaosat",
              ru: "Угловая фурнитура",
              gr: "Eckbeschläge"
            },
            image: "categories/fasadbleck/hornbeslag/hornbeslag_stor.jpg",
            description: {
              sw: "Hörnbeslag skyddar väggar och hörn, och används både interiört och exteriört.",
              en: "Corner fittings protect walls and corners, and are used both internally and externally.",
              nor: "Hjørneinnredninger beskytter vegger og hjørner, og brukes både innvendig og utvendig.",
              da: "Hjørnebeslag beskytter vægge og hjørner og bruges både indvendigt og udvendigt.",
              fin: "Kulmaliittimet suojaavat seiniä ja kulmia, ja niitä käytetään sekä sisäisesti että ulkoisesti.",
              ru: "Угловая фурнитура защищает стены и углы и используется как внутри, так и снаружи.",
              gr: "Eckbeschläge schützen Wände und Ecken und werden im Innen- und Außenbereich eingesetzt."
            },
            
          },
          {
            name: "Pilaster",
            label: {
              sw: "Pilaster",
              en: "Pilaster",
              nor: "Pilaster",
              da: "Pilaster",
              fin: "Pilasteri",
              ru: "Пилястра",
              gr: "Pilaster"
            },
            image: "categories/fasadbleck/pilaster/pilaster.jpg",
            description: {
              sw: "Pilaster används för att täcka skarvar där isoleringselement och fönster möter varandra.",
              en: "Pilasters are used to cover joints where insulation elements and windows meet.",
              nor: "Pilastere brukes til å dekke skjøter der isolasjonselementer og vinduer møtes.",
              da: "Pilastre bruges til at dække samlinger, hvor isolerende elementer og vinduer mødes.",
              fin: "Pilastereita käytetään liitosten peittämiseen kohdissa, joissa eristävät elementit ja ikkunat kohtaavat.",
              ru: "Пилястры закрывают стыки стыков изоляционных элементов и окон.",
              gr: "Pilaster werden verwendet, um Fugen abzudecken, wo Dämmelemente und Fenster aufeinandertreffen."
            },
          },
        ],
      },
      {
        name: "Takbeslag",
        label: {
          sw: "Takbeslag",
          en: "Roof fittings",
          nor: "Takbeslag",
          da: "Tagbeslag",
          fin: "Katon varusteet",
          ru: "Кровельная фурнитура",
          gr: "Dachbeschläge"
        },
        image: "categories/takbeslag/nockbeslag_overlaggsplattor_1.png",
        description: {
          sw: "Här finns takbeslag som monteras på tak. Till exempel vindskivor och nockplåtar.",
          en: "Here are roof fittings that are mounted on the roof. For example, windshields and ridge plates.",
          nor: "Her er takbeslag som er montert på taket. For eksempel frontruter og ryggplater.",
          da: "Her er tagbeslag, der er monteret på taget. For eksempel forruder og rygplader.",
          fin: "Tässä ovat kattokiinnikkeet, jotka on asennettu katolle. Esimerkiksi tuulilasit ja harjanteet.",
          ru: "Вот кровельная арматура, которая монтируется на крышу. Например, лобовые стекла и коньковые накладки.",
          gr: "Hier sind Dachbeschläge, die auf dem Dach montiert werden. Zum Beispiel Windschutzscheiben und Firstbleche."
        },
        contents: [
          {
            name: "Fotplåt",
            label: {
              sw: "Fotplåt",
              en: "Foot plate",
              nor: "Fotplate",
              da: "Fodplade",
              fin: "Jalkalevy",
              ru: "Подножка",
              gr: "Fußplatte"
            },
            image: "categories/takbeslag/fotplat/fotplat.jpg",
            description: {
              sw: "Fotplåtar monteras ovanför hängrännor.",
              en: "Footplates are mounted above gutters.",
              nor: "Fotplater er montert over takrenner.",
              da: "Fodplader er monteret over tagrender.",
              fin: "Pohjalevyt on asennettu kourujen yläpuolelle.",
              ru: "Подножка",
              gr: "Fußplatten werden über Rinnen montiert."
            },
            
          },
          {
            name: "Ståndskivor",
            label: {
              sw: "Ståndskivor",
              en: "Stand plates",
              nor: "Stativplater",
              da: "Stativplader",
              fin: "Jalustat",
              ru: "Подставка для тарелок",
              gr: "Standplatten"
            },
            image: "categories/takbeslag/standskiva/standskiva_med_vinge.png",
            description: {
              sw: "Ståndskivor finns där tak möter vägg, oftast vid utbyggnader på tak.",
              en: "Stand plates are found where the roof meets the wall, usually in the case of extensions to the roof.",
              nor: "Stativplater finnes der taket møter veggen, vanligvis når det gjelder forlengelser av taket.",
              da: "Standplader findes, hvor taget møder væggen, normalt i tilfælde af udvidelser af taget.",
              fin: "Jalustalevyjä löytyy kohdasta, jossa katto kohtaa seinän, yleensä katon jatkeissa.",
              ru: "Плиты подставки находятся там, где крыша встречается со стеной, обычно в случае пристройки к крыше.",
              gr: "Standplatten finden sich dort, wo das Dach auf die Wand trifft, meist bei Dachanbauten."
            },
          },
          {
            name: "Krönbeslag",
            label: {
              sw: "Krönbeslag",
              en: "Crown fittings",
              nor: "Kronebeslag",
              da: "Kronebeslag",
              fin: "Kruunu varusteet",
              ru: "Корона фурнитура",
              gr: "Kronenbeschläge"
            },
            image: "categories/takbeslag/kronbeslag/kronbeslag_3_delat_droppbleck_2.png",
            description: {
              sw: "Två- och tredelade rönbeslag med hängskiva och droppbleck.",
              en: "Crown fittings that are easy to assemble. Available with hanging plate and drip tray.",
              nor: "Kronebeslag som er enkle å montere. Fås med hengende plate og dryppbrett.",
              da: "Kronebeslag, der er nemme at montere. Fås med hængende plade og drypbakke.",
              fin: "Kruunuosat, jotka on helppo asentaa. Saatavana ripustettavalla levyllä ja tippa-alustalla.",
              ru: "Легко монтируемые коронки. Доступен с подвесной пластиной и поддоном для сбора капель.",
              gr: "Kronenbeschläge, die einfach zu montieren sind. Erhältlich mit Aufhängeplatte und Tropfschale."
            },
          },
          {
            name: "Vindskiveplåtar",
            label: {
              sw: "Vindskiveplåtar",
              en: "Windshield plates",
              nor: "Vindusplater",
              da: "Forrudeplader",
              fin: "Tuulilasin levyt",
              ru: "Пластины лобового стекла",
              gr: "Windschutzscheibenplatten"
            },
            image: "categories/takbeslag/vindskiva/vindskivebeslag_hangskiva/vindskivebeslag_hangskiva.png",
            description: {
              sw: "Vindskiveplåtar finns längst ut på takets vindskivor.",
              en: "Windshield panels are located at the far end of the roof windshields.",
              nor: "Vindskjermpaneler er plassert ytterst på takruten.",
              da: "Vindrudepaneler er placeret i den yderste ende af tagruderne.",
              fin: "Tuulilasin levyt ovat katon tuulilasin perässä.",
              ru: "Панели лобового стекла расположены в дальнем конце лобовых стекол крыши.",
              gr: "Windschutzscheibenbleche befinden sich am anderen Ende der Dachwindschutzscheiben."
            },
          },
          {
            name: "Vinkelrännor",
            label: {
              sw: "Vinkelrännor",
              en: "Angle gutters",
              nor: "Vinkelrender",
              da: "Kulmakourut",
              fin: "Kulmakourut",
              ru: "Угловые желоба",
              gr: "Winkelrinnen"
            },
            image: "categories/takbeslag/vinkelranna/vinkelranna_forsankt.jpg",
            description: {
              sw: "Vinkelrännor finns där tak möter varandra. Vinkelrännor leder vatten ner till hängränna.",
              en: "Angled gutters are located where roofs meet. Angled gutters lead water down to the gutter.",
              nor: "Vinklede takrenner er plassert der tak møter hverandre. Vinklede takrenner fører vann ned til takrennen.",
              da: "Vinklede tagrender er placeret, hvor tagene møder hinanden. Vinklede tagrender fører vand ned til tagrenden.",
              fin: "Kulmaiset kourut sijaitsevat katojen kohtaamispaikoissa. Kallistetut kourut johtavat veden alas kouruun.",
              ru: "Угловые желоба располагаются там, где крыши встречаются друг с другом. Из наклонных желобов вода спускается в желоб.",
              gr: "Abgewinkelte Dachrinnen befinden sich dort, wo Dächer aufeinandertreffen. Abgewinkelte Rinnen führen das Wasser in die Rinne."
            },
            
          },
          {
            name: "Nockbeslag",
            label: {
              sw: "Nockbeslag",
              en: "Cam plates",
              nor: "Kamplater",
              da: "Cam plader",
              fin: "Nokkalevyt",
              ru: "Кулачковые пластины",
              gr: "Kurvenscheiben"
            },
            image: "categories/takbeslag/nockbeslag/nockbeslag_overlaggsplattor_1.png",
            description: {
              sw: "Nockbeslag finns högst upp på taket.",
              en: "Cam plates are located at the top of the roof.",
              nor: "Kamplater er plassert øverst på taket.",
              da: "Kamplader er placeret øverst på taget.",
              fin: "Nokkalevyt sijaitsevat katon yläosassa.",
              ru: "Пластины кулачка расположены в верхней части крыши.",
              gr: "Kurvenscheiben befinden sich oben auf dem Dach."
            },
            
          },
          {
            name: "Skyddsplåt bakom ränna",
            label: {
              sw: "Skyddsplåt bakom ränna",
              en: "Protective plate behind gutter",
              nor: "Beskyttelsesplate bak takrennen",
              da: "Beskyttelsesplade bag tagrenden",
              fin: "Suojalevy kourun takana",
              ru: "Защитная пластина за желобом",
              gr: "Schutzblech hinter Dachrinne"
            },
            image:
              "categories/takbeslag/skyddsbeslag_bakom_hangranna/skyddsbeslag_bakom_ranna_droppbleck.png",
            description: {
              sw: "Skyddsplåt bakom ränna skyddar takfoten bakom hängrännan från vatten.",
              en: "Protective plate behind gutter protects the eaves behind the gutter from water.",
              nor: "Beskyttelsesplate bak takrennen beskytter takskjegget bak takrennen mot vann.",
              da: "Beskyttelsesplade bag tagrenden beskytter tagskærmen bag tagrenden mod vand.",
              fin: "Kourun takana oleva suojalevy suojaa kourun takana olevaa räystää vedeltä.",
              ru: "Защитная пластина за желобом защищает карниз за желобом от воды.",
              gr: "Schutzblech hinter der Rinne schützt die Traufe hinter der Rinne vor Wasser."
            },
          },
        ],
      },
      {
        name: "Takhinder",
        label: {
          sw: "Takhinder",
          en: "Roof barriers",
          nor: "Takbarrierer",
          da: "Tagbarrierer",
          fin: "Katon esteet",
          ru: "Кровельные ограждения",
          gr: "Dachbarrieren"
        },
        image: "categories/takhinder/stos_kinahatt.jpg",
        description: {
          sw: "Här finns plåtprodukter som monteras runt takhinder på taket. Till exempel sarger runt takluckor.",
          en: "Here are sheet metal products that are mounted around roof barriers on the roof. For example, frames around sunroofs.",
          nor: "Her er metallplater som er montert rundt takbarrierer på taket. For eksempel rammer rundt soltak.",
          da: "Her er metalpladeprodukter, der er monteret omkring tagbarrierer på taget. For eksempel rammer omkring soltag.",
          fin: "Tässä ovat ohutlevytuotteet, jotka on asennettu katon kattoesteiden ympärille. Esimerkiksi kehykset kattoluukkujen ympärillä.",
          ru: "Вот изделия из листового металла, которые устанавливаются вокруг кровельных ограждений на крыше. Например, рамы вокруг люков.",
          gr: "Hier sind Blechprodukte, die um Dachbarrieren auf dem Dach montiert werden. Zum Beispiel Rahmen um Schiebedächer."
        },
        contents: [
          {
            name: "Takfönster",
            label: {
              sw: "Takfönster",
              en: "Skylight",
              nor: "Himmellys",
              da: "Ovenlysvindue",
              fin: "Kattoikkuna",
              ru: "Свет неба",
              gr: "Dachfenster"
            },
            image: "placeholder.png",
            description: {
              sw: "Plåtsarger runt takfönster består av fyra plåtsarger som som falsas samman runt takfönstrets fyra sidor.",
              en: "Sheet metal frames around skylights consist of four sheet metal frames that are folded together around the four sides of the skylight.",
              nor: "Platerammer rundt takvinduer består av fire metallplaterammer som er brettet sammen rundt takvinduets fire sider.",
              da: "Arkrammer omkring ovenlys består af fire metalpladerammer, der er foldet sammen rundt om ovenlysvinduet.",
              fin: "Kattoikkunoiden ympärillä olevat peltikehykset koostuvat neljästä metallilevykehyksestä, jotka on taitettu yhteen kattoikkunan neljän sivun ympäri.",
              ru: "Каркасы из листового металла вокруг световых люков состоят из четырех рам из листового металла, которые сложены вместе вокруг четырех сторон светового люка.",
              gr: "Blechrahmen um Oberlichter bestehen aus vier Blechrahmen, die um die vier Seiten des Oberlichts zusammengefaltet werden."
            },
            
          },
          {
            name: "Rökluckor",
            label: {
              sw: "Rökluckor",
              en: "Sheet metal frames around smoke hatches",
              nor: "Platerammer rundt røykluker",
              da: "Rammer af metalplader omkring røgluger",
              fin: "Peltikehykset savuluukkujen ympärillä",
              ru: "Каркасы из листового металла вокруг дымовых люков",
              gr: "Blechrahmen um Rauchluken"
            },
            image: "placeholder.png",
            description: {
              sw: "Fyra plåtsarger som som falsas samman runt röckluckans fyra sidor.",
              en: "Four sheet metal frames that fold together around the four sides of the smoke hatch. ",
              nor: "Fire kanter av metallplater som brettes sammen rundt de fire sidene av røykluken.",
              da: "Fire kanter af metalplader, der foldes sammen omkring de fire sider af røglugen.",
              fin: "Neljä peltireunaa, jotka taittuvat yhteen savuluukun neljän sivun ympärille.",
              ru: "Четыре кромки из листового металла, которые складываются вокруг четырех сторон дымового люка.",
              gr: "Vier Blechkanten, die sich um die vier Seiten der Rauchluke zusammenfalten."
            },
          },
          {
            name: "Uppstigningsluckor",
            label: {
              sw: "Uppstigningsluckor",
              en: "Sheet metal frames around sunroofs",
              nor: "Platerammer rundt soltak",
              da: "Rammer af metalplader omkring soltagene",
              fin: "Peltikehykset kattoluukkujen ympärillä",
              ru: "Каркасы из листового металла вокруг люков",
              gr: "Blechrahmen um Schiebedächer"
            },
            image: "placeholder.png",
            description: {
              sw: "Fyra plåtsarger som som falsas samman runt takluckans fyra sidor.",
              en: "Four sheet metal frames that are folded around the four sides of the sunroof.",
              nor: "Fire metallrammer som er brettet rundt de fire sidene av taket.",
              da: "Fire metalpladerammer, der er foldet rundt om soltagets fire sider.",
              fin: "Neljä metallilevykehystä, jotka on taitettu kattoluukun neljän sivun ympärille.",
              ru: "Четыре рамы из листового металла, загнутые вокруг четырех сторон люка.",
              gr: "Vier Blechrahmen, die um die vier Seiten des Schiebedachs gefaltet werden."
            },
          },
          {
            name: "Ventilationshuvar",
            label: {
              sw: "Ventilationshuvar",
              en: "Ventilation hoods",
              nor: "Ventilasjonshetter",
              da: "Ventilationshætter",
              fin: "Ilmanvaihtohuput",
              ru: "Вытяжки вентиляционные",
              gr: "Lüftungshauben"
            },
            image: "placeholder.png",
            description: {
              sw: "Ventilationshuvar i olika storlekar och utföranden.",
              en: "Ventilation hoods in different sizes and designs.",
              nor: "Ventilasjonshetter i forskjellige størrelser og design.",
              da: "Ventilationshætter i forskellige størrelser og design.",
              fin: "Ilmanvaihtohuput erikokoisina ja erikokoisina.",
              ru: "Вытяжки различных размеров и исполнения.",
              gr: "Lüftungshauben in verschiedenen Größen und Ausführungen."
            },
          },
          {
            name: "Stosar",
            label: {
              sw: "Stosar",
              en: "Stosar",
              nor: "Stosar",
              da: "Stosar",
              fin: "Stosar",
              ru: "Стосар",
              gr: "Stosar"
            },
            image: "categories/takhinder/stosar/stos_kinahatt.jpg",
            description: {
              sw: "Stosar finns för plåttak och tegeltak i olika utföranden.",
              en: "Sockets are available for metal roofs and tile roofs in various designs.",
              nor: "Stikkontakter er tilgjengelige for metalltak og flistak i forskjellige utførelser.",
              da: "Stik fås til metaltage og tegltage i forskellige designs.",
              fin: "Pistorasioita on saatavana eri malleina metallikatoille ja tiilikatoille.",
              ru: "Розетки доступны для металлических и черепичных крыш в различных исполнениях.",
              gr: "Für Metalldächer und Ziegeldächer gibt es Steckdosen in verschiedenen Ausführungen."
            },
          },
          {
            name: "Skorstenar",
            label: {
              sw: "Skorstenar",
              en: "Sheet metal frames around chimneys",
              nor: "Platerammer rundt skorsteiner",
              da: "Stålpladerammer omkring skorstene",
              fin: "Peltikehykset savupiippujen ympärillä",
              ru: "Каркасы из листового металла вокруг дымоходов",
              gr: "Blechrahmen um Schornsteine"
            },
            image: "placeholder.png",
            description: {
              sw: "Fyra plåtsarger som som falsas samman runt skorstenens fyra sidor.",
              en: "Four sheet metal frames that are folded around the four sides of the chimney.",
              nor: "Fire metallrammer som er brettet rundt skorsteins fire sider.",
              da: "Fire pladerammer, der er foldet rundt om skorstens fire sider.",
              fin: "Neljä peltiä, jotka on taitettu savupiipun neljän sivun ympärille.",
              ru: "Четыре каркаса из листового металла, загнутые вокруг четырех сторон дымохода.",
              gr: "Vier Blechrahmen, die um die vier Seiten des Schornsteins gefaltet werden."
            },
          },
        ],
      },
      {
        name: "Vattenavledning",
        label: {
          sw: "Vattenavledning",
          en: "Water drainage",
          nor: "Vanndrenering",
          da: "Vandafløb",
          fin: "Vedenpoisto",
          ru: "Отвод воды",
          gr: "Wasserablauf"
        },
        image: "categories/takbeslag/vinkelranna/vinkelranna_forsankt.jpg",
        description: {
          sw: "Byggnadsplåtsprodukter som leder vatten ut till stuprören.",
          en: "Sheet metal products that lead water out to the downpipes.",
          nor: "Plateprodukter som fører vann ut til nedløpsrørene.",
          da: "Metalplader, der fører vand ud til nedrørene.",
          fin: "Peltituotteet, jotka johtavat vettä ulos putkiin.",
          ru: "Byggnadsplåtsprodukter som leder vatten ut till stuprören.",
          gr: "Blechprodukte, die Wasser zu den Fallrohren führen."
        },
      contents: [
        {
          name: "Vinkelrännor",
          label: {
            sw: "Vinkelrännor",
            en: "Skylight",
            nor: "Himmellys",
            da: "Ovenlysvindue",
            fin: "Kattoikkuna",
            ru: "Свет неба",
            gr: "Dachfenster"
          },
          image: "categories/takbeslag/vinkelranna/vinkelranna_bandtackning/vinkelranna_bandtackning.png",
          description: {
            sw: "Plåtsarger runt takfönster består av fyra plåtsarger som som falsas samman runt takfönstrets fyra sidor.",
            en: "Sheet metal frames around skylights consist of four sheet metal frames that are folded together around the four sides of the skylight.",
            nor: "Platerammer rundt takvinduer består av fire metallplaterammer som er brettet sammen rundt takvinduets fire sider.",
            da: "Arkrammer omkring ovenlys består af fire metalpladerammer, der er foldet sammen rundt om ovenlysvinduet.",
            fin: "Kattoikkunoiden ympärillä olevat peltikehykset koostuvat neljästä metallilevykehyksestä, jotka on taitettu yhteen kattoikkunan neljän sivun ympäri.",
            ru: "Каркасы из листового металла вокруг световых люков состоят из четырех рам из листового металла, которые сложены вместе вокруг четырех сторон светового люка.",
            gr: "Blechrahmen um Oberlichter bestehen aus vier Blechrahmen, die um die vier Seiten des Oberlichts zusammengefaltet werden."
            },
          },
          {
            name: "Fotrännor",
            label: {
              sw: "Fotrännor",
              en: "Skylight",
              nor: "Himmellys",
              da: "Ovenlysvindue",
              fin: "Kattoikkuna",
              ru: "Свет неба",
              gr: "Dachfenster"
            },
            image: "placeholder.png",
            description: {
              sw: "Plåtsarger runt takfönster består av fyra plåtsarger som som falsas samman runt takfönstrets fyra sidor.",
              en: "Sheet metal frames around skylights consist of four sheet metal frames that are folded together around the four sides of the skylight.",
              nor: "Platerammer rundt takvinduer består av fire metallplaterammer som er brettet sammen rundt takvinduets fire sider.",
              da: "Arkrammer omkring ovenlys består af fire metalpladerammer, der er foldet sammen rundt om ovenlysvinduet.",
              fin: "Kattoikkunoiden ympärillä olevat peltikehykset koostuvat neljästä metallilevykehyksestä, jotka on taitettu yhteen kattoikkunan neljän sivun ympäri.",
              ru: "Каркасы из листового металла вокруг световых люков состоят из четырех рам из листового металла, которые сложены вместе вокруг четырех сторон светового люка.",
              gr: "Blechrahmen um Oberlichter bestehen aus vier Blechrahmen, die um die vier Seiten des Oberlichts zusammengefaltet werden."
            },
          },
          {
            name: "Gesimsrännor",
            label: {
              sw: "Gesimsrännor",
              en: "Skylight",
              nor: "Himmellys",
              da: "Ovenlysvindue",
              fin: "Kattoikkuna",
              ru: "Свет неба",
              gr: "Dachfenster"
            },
            image: "placeholder.png",
            description: {
              sw: "Plåtsarger runt takfönster består av fyra plåtsarger som som falsas samman runt takfönstrets fyra sidor.",
              en: "Sheet metal frames around skylights consist of four sheet metal frames that are folded together around the four sides of the skylight.",
              nor: "Platerammer rundt takvinduer består av fire metallplaterammer som er brettet sammen rundt takvinduets fire sider.",
              da: "Arkrammer omkring ovenlys består af fire metalpladerammer, der er foldet sammen rundt om ovenlysvinduet.",
              fin: "Kattoikkunoiden ympärillä olevat peltikehykset koostuvat neljästä metallilevykehyksestä, jotka on taitettu yhteen kattoikkunan neljän sivun ympäri.",
              ru: "Каркасы из листового металла вокруг световых люков состоят из четырех рам из листового металла, которые сложены вместе вокруг четырех сторон светового люка.",
              gr: "Blechrahmen um Oberlichter bestehen aus vier Blechrahmen, die um die vier Seiten des Oberlichts zusammengefaltet werden."
            },
          },
        ],
      },
      {
        name: "Profiler",
        label: {
          sw: "Profiler",
          en: "Profiles",
          nor: "Profiler",
          da: "Profiler",
          fin: "Profiilit",
          ru: "Профили",
          gr: "Profile"
        },
        image: "categories/profiler/c_profil.jpg",
        description: {
          sw: "Lättbalkar och stålprofiler för en lätt och stark konstruktion.",
          en: "Light beams and steel profiles for a light and strong construction.",
          nor: "Lysbjelker og stålprofiler for en lett og sterk konstruksjon.",
          da: "Lysbjælker og stålprofiler til en let og stærk konstruktion.",
          fin: "Valopalkit ja teräsprofiilit takaavat kevyen ja vahvan rakenteen.",
          ru: "Lättbalkar och stålprofiler för en lätt och stark konstruktion.",
          gr: "Lichtbalken und Stahlprofile für eine leichte und stabile Konstruktion."
        },
      },
      {
        name: "Schaktplåtar",
        label: {
          sw: "Schaktplåtar",
          en: "Dozer plates",
          nor: "Bulldoser",
          da: "Bulldozere",
          fin: "Puskulevyt",
          ru: "Бульдозерные плиты",
          gr: "Planierschild"
        },
        image: "categories/schaktplatar/schaktplat_3_uppvik.jpg",
        description: {
          sw: "Här kan du beställa schaktplåtar och schaktlådor som täcker hål i betonggolvet.",
          en: "Here you can order shaft plates and shaft boxes that cover holes in the concrete floor.",
          nor: "Her kan du bestille sjaktplater og sjaktkasser som dekker hull i betonggulvet.",
          da: "Her kan du bestille akselplader og akselkasser, der dækker huller i betongulvet.",
          fin: "Täältä voit tilata akselilevyjä ja akselilaatikoita, jotka peittävät reiät betonilattiassa.",
          ru: "Здесь вы можете заказать шахтные плиты и шахты, закрывающие отверстия в бетонном полу.",
          gr: "Hier können Sie Schachtplatten und Schachtkästen bestellen, die Löcher im Betonboden abdecken."
        },
      },
      {
        name: "Bandtäckning",
        label: {
          sw: "Bandtäckning",
          en: "Band coverage",
          nor: "Banddekning",
          da: "Banddækning",
          fin: "Bändin kattavuus",
          ru: "Покрытие диапазона",
          gr: "Bandabdeckung"
        },
        image: "categories/bandtackning/bandtackning.jpg",
        description: {
          sw: "Här kan du måttbeställa bandtäckningskivor.",
          en: "Here you can order custom-made tape covers.",
          nor: "Her kan du bestille spesialtilpassede tapetdeksler.",
          da: "Her kan du bestille skræddersyede tapeovertræk.",
          fin: "Täältä voit tilata mittatilaustyönä tehdyt teippikannet.",
          ru: "Здесь вы можете заказать чехлы из ленты на заказ.",
          gr: "Hier können Sie maßgeschneiderte Klebebandabdeckungen bestellen."
        },
        contents: [
          {
            name: "Bandtäckningsskivor",
            label: {
              sw: "Bandtäckningsskivor",
              en: "Band coverage",
              nor: "Banddekning",
              da: "Banddækning",
              fin: "Bändin kattavuus",
              ru: "Покрытие диапазона",
              gr: "Bandabdeckung"
            },
            image: "categories/bandtackning/bandtackning.jpg",
            description: {
              sw: "Här kan du beställa schaktplåtar och schaktlådor som täcker hål i betonggolvet.",
              en: "Here you can order shaft plates and shaft boxes that cover holes in the concrete floor.",
              nor: "Her kan du bestille sjaktplater og sjaktkasser som dekker hull i betonggulvet.",
              da: "Her kan du bestille akselplader og akselkasser, der dækker huller i betongulvet.",
              fin: "Täältä voit tilata akselilevyjä ja akselilaatikoita, jotka peittävät reiät betonilattiassa.",
              ru: "Здесь вы можете заказать шахтные плиты и шахты, закрывающие отверстия в бетонном полу.",
              gr: "Hier können Sie Schachtplatten und Schachtkästen bestellen, die Löcher im Betonboden abdecken."
            },
          },
          {
            name: "Ståndskivor för bandtäckning",
            label: {
              sw: "Ståndskivor för bandtäckning",
              en: "Band coverage",
              nor: "Banddekning",
              da: "Banddækning",
              fin: "Bändin kattavuus",
              ru: "Покрытие диапазона",
              gr: "Bandabdeckung"
            },
            image: "categories/takbeslag/standskiva/standskiva_bandtackning_langsgaende/hoger/hogfals/standskiva_hoger_hogfals.png",
            description: {
              sw: "Här kan du beställa schaktplåtar och schaktlådor som täcker hål i betonggolvet.",
              en: "Here you can order shaft plates and shaft boxes that cover holes in the concrete floor.",
              nor: "Her kan du bestille sjaktplater og sjaktkasser som dekker hull i betonggulvet.",
              da: "Her kan du bestille akselplader og akselkasser, der dækker huller i betongulvet.",
              fin: "Täältä voit tilata akselilevyjä ja akselilaatikoita, jotka peittävät reiät betonilattiassa.",
              ru: "Здесь вы можете заказать шахтные плиты и шахты, закрывающие отверстия в бетонном полу.",
              gr: "Hier können Sie Schachtplatten und Schachtkästen bestellen, die Löcher im Betonboden abdecken."
            },
          },
          {
            name: "Nockbeslag för bandtäckning",
            label: {
              sw: "Nockbeslag för bandtäckning",
              en: "Band coverage",
              nor: "Banddekning",
              da: "Banddækning",
              fin: "Bändin kattavuus",
              ru: "Покрытие диапазона",
              gr: "Bandabdeckung"
            },
            image: "categories/takbeslag/nockbeslag/nockbeslag_bandtackning/nockbeslag_bandtackning.png",
            description: {
              sw: "Här kan du beställa schaktplåtar och schaktlådor som täcker hål i betonggolvet.",
              en: "Here you can order shaft plates and shaft boxes that cover holes in the concrete floor.",
              nor: "Her kan du bestille sjaktplater og sjaktkasser som dekker hull i betonggulvet.",
              da: "Her kan du bestille akselplader og akselkasser, der dækker huller i betongulvet.",
              fin: "Täältä voit tilata akselilevyjä ja akselilaatikoita, jotka peittävät reiät betonilattiassa.",
              ru: "Здесь вы можете заказать шахтные плиты и шахты, закрывающие отверстия в бетонном полу.",
              gr: "Hier können Sie Schachtplatten und Schachtkästen bestellen, die Löcher im Betonboden abdecken."
            },
          },
          {
            name: "Vinkelränna för bandtäckning",
            label: {
              sw: "Vinkelränna för bandtäckning",
              en: "Band coverage",
              nor: "Banddekning",
              da: "Banddækning",
              fin: "Bändin kattavuus",
              ru: "Покрытие диапазона",
              gr: "Bandabdeckung"
            },
            image: "categories/takbeslag/vinkelranna/vinkelranna_bandtackning/vinkelranna_bandtackning.png",
            description: {
              sw: "Här kan du beställa schaktplåtar och schaktlådor som täcker hål i betonggolvet.",
              en: "Here you can order shaft plates and shaft boxes that cover holes in the concrete floor.",
              nor: "Her kan du bestille sjaktplater og sjaktkasser som dekker hull i betonggulvet.",
              da: "Her kan du bestille akselplader og akselkasser, der dækker huller i betongulvet.",
              fin: "Täältä voit tilata akselilevyjä ja akselilaatikoita, jotka peittävät reiät betonilattiassa.",
              ru: "Здесь вы можете заказать шахтные плиты и шахты, закрывающие отверстия в бетонном полу.",
              gr: "Hier können Sie Schachtplatten und Schachtkästen bestellen, die Löcher im Betonboden abdecken."
            },
          },
          {
            name: "Språngplåt för bandtäckning",
            label: {
              sw: "Språngplåt för bandtäckning",
              en: "Band coverage",
              nor: "Banddekning",
              da: "Banddækning",
              fin: "Bändin kattavuus",
              ru: "Покрытие диапазона",
              gr: "Bandabdeckung"
            },
            image: "categories/takbeslag/fotplat/sprangplat/sprangplat.jpg",
            description: {
              sw: "Här kan du beställa schaktplåtar och schaktlådor som täcker hål i betonggolvet.",
              en: "Here you can order shaft plates and shaft boxes that cover holes in the concrete floor.",
              nor: "Her kan du bestille sjaktplater og sjaktkasser som dekker hull i betonggulvet.",
              da: "Her kan du bestille akselplader og akselkasser, der dækker huller i betongulvet.",
              fin: "Täältä voit tilata akselilevyjä ja akselilaatikoita, jotka peittävät reiät betonilattiassa.",
              ru: "Здесь вы можете заказать шахтные плиты и шахты, закрывающие отверстия в бетонном полу.",
              gr: "Hier können Sie Schachtplatten und Schachtkästen bestellen, die Löcher im Betonboden abdecken."
            },
          },
        ],
      },
      {
        name: "Fönster- & dörromfattningar",
        label: {
          sw: "Fönster- & dörromfattningar",
          en: "Fönster- & dörromfattningar",
          nor: "Fönster- & dörromfattningar",
          da: "Fönster- & dörromfattningar",
          fin: "Fönster- & dörromfattningar",
          ru: "Fönster- & dörromfattningar",
          gr: "Fönster- & dörromfattningar"
        },
        image: "categories/ovrigt/z_troskel.png",
        description: {
          sw: "Här samlas alla plåtomfattningar för fönster och dörrar.",
          en: "Här samlas alla plåtomfattningar för fönster och dörrar.",
          nor: "Här samlas alla plåtomfattningar för fönster och dörrar.",
          da: "Här samlas alla plåtomfattningar för fönster och dörrar.",
          fin: "Här samlas alla plåtomfattningar för fönster och dörrar.",
          ru: "Här samlas alla plåtomfattningar för fönster och dörrar.",
          gr: "Här samlas alla plåtomfattningar för fönster och dörrar."
        }, 
      },
      {
        name: "Övrigt",
        label: {
          sw: "Övrigt",
          en: "Other",
          nor: "Annen",
          da: "Andet",
          fin: "Muu",
          ru: "Другой",
          gr: "Sonstiges"
        },
        image: "categories/ovrigt/z_troskel.png",
        description: {
          sw: "Här samlas alla plåtprodoukter som ännu inte fått en kategori.",
          en: "All sheet metal products that have not yet received a category are gathered here.",
          nor: "Alle metallprodukter som ennå ikke har mottatt en kategori er samlet her.",
          da: "Alle metalpladeprodukter, der endnu ikke har modtaget en kategori, er samlet her.",
          fin: "Kaikki peltituotteet, jotka eivät ole vielä saaneet luokkaa, on koottu tähän.",
          ru: "Здесь собраны все изделия из листового металла, еще не получившие категорию.",
          gr: "Hier werden alle Blechprodukte gesammelt, die noch keine Kategorie erhalten haben."
        },
        
      },
    ],
  },
  {
    name: "Vattenavrinning",
    label: {
      sw: "Vattenavrinning",
      en: "Water runoff",
      nor: "Vannavrenning",
      da: "Vandafstrømning",
      fin: "Veden valuminen",
      ru: "Сток воды",
      gr: "Wasserabfluss"
    },
    contents: [
      {
        name: "Stuprör",
        label: {
          sw: "Stuprör",
          en: "Pipe",
          nor: "Rør",
          da: "Rør",
          fin: "Putki",
          ru: "Трубка",
          gr: "Rohr"
        },
        contents: [],
        image: "vattenavrinning/stupror/stupror/stupror.png",
        type: "stuprör",
      },
      {
        name: "Svep",
        label: {
          sw: "Svep",
          en: "Sweep",
          nor: "Feie",
          da: "Feje",
          fin: "Lakaista",
          ru: "Сметать",
          gr: "Fegen"
        },
        contents: [],
        image:
          "vattenavrinning/stupror/rorsvep_travagg_med_kil/rorsvep_travagg_med_kil.png",
        type: "stuprör",
      },
      {
        name: "Rörvinkel",
        label: {
          sw: "Rörvinkel",
          en: "Pipe angle",
          nor: "Rørvinkel",
          da: "Rørvinkel",
          fin: "Putken kulma",
          ru: "Угол трубы",
          gr: "Rohrwinkel"
        },
        contents: [],
        image:
          "vattenavrinning/stupror/rorvinkel/rorvinkel_60/rorvinkel_60.png",
        type: "stuprör",
      },
      {
        name: "Omvikningskupa",
        label: {
          sw: "Omvikningskupa",
          en: "Folding cup",
          nor: "Sammenleggbar kopp",
          da: "Foldekop",
          fin: "Taitettava kuppi",
          ru: "Складная чашка",
          gr: "Klappbecher"
        },
        contents: [],
        image:
          "vattenavrinning/hangranna/omvikningskupa/omvikningskupa_100.png",
        type: "stuprör",
      },
      {
        name: "Vattenkupa",
        label: {
          sw: "Vattenkupa",
          en: "Water cup",
          nor: "Vannkopp",
          da: "Vandkop",
          fin: "Veden kuppi",
          ru: "Чашка для воды",
          gr: "Wasserbecher"
        },
        contents: [],
        image: "vattenavrinning/stupror/vattenkupa/vattenkupa_svart.jpg",
        type: "stuprör",
      },
      {
        name: "Utkastare",
        label: {
          sw: "Utkastare",
          en: "Ejector",
          nor: "Ejektor",
          da: "Ejektor",
          fin: "Ejektori",
          ru: "Выталкиватель",
          gr: "Auswerfer"
        },
        contents: [],
        image: "vattenavrinning/stupror/utkastare/utkastare.png",
        type: "stuprör",
      },
      {
        name: "Renstratt",
        label: {
          sw: "Renstratt",
          en: "",
          nor: "",
          da: "",
          fin: "",
          ru: "",
          gr: ""
        },
        contents: [],
        image: "vattenavrinning/stupror/renstratt/renstratt.png",
        type: "stuprör",
      },
      {
        name: "Tubrör",
        label: {
          sw: "Tubrör",
          en: "Tubes",
          nor: "Rør",
          da: "Rør",
          fin: "Putket",
          ru: "Трубки",
          gr: "Rohre"
        },
        contents: [],
        image:
          "vattenavrinning/stupror/vandalror_med_lovsil/vandalror_med_lovsil.png",
        type: "stuprör",
      },
      {
        name: "Brunnsutkastare",
        label: {
          sw: "Brunnsutkastare",
          en: "Well ejector",
          nor: "Vel ejektor",
          da: "Nå ejektor",
          fin: "No ejektori",
          ru: "Эжектор скважины",
          gr: "Brunnenauswerfer"
        },
        contents: [],
        image: "vattenavrinning/stupror/brunnsutkastare/brunnsutkastare.png",
        type: "stuprör",
      },
      {
        name: "Grenrör",
        label: {
          sw: "Grenrör",
          en: "Manifold",
          nor: "Fordeler",
          da: "Manifold",
          fin: "Jakotukki",
          ru: "Многообразие",
          gr: "Verteiler"
        },
        contents: [],
        image: "vattenavrinning/stupror/grenror_60/grenror_60.png",
        type: "stuprör",
      },
      {
        name: "Övrigt",
        label: {
          sw: "Övrigt",
          en: "Others",
          nor: "",
          da: "",
          fin: "",
          ru: "",
          gr: ""
        },
        contents: [],
        image: "vattenavrinning/stupror/sockelkna/sockelkna.png",
        type: "stuprör",
      },
      {
        name: "Hängränna",
        label: {
          sw: "Hängränna",
          en: "Gutter",
          nor: "Takrenne",
          da: "Rende",
          fin: "Kouru",
          ru: "Желоб",
          gr: "Rinne"
        },
        contents: [],
        image: "vattenavrinning/hangranna/hangranna/hangranna_1.png",
        type: "hängränna",
      },
      {
        name: "Krok",
        label: {
          sw: "Krok",
          en: "Hook",
          nor: "Hook",
          da: "Krog",
          fin: "Koukku",
          ru: "Крюк",
          gr: "Haken"
        },
        contents: [],
        image:
          "vattenavrinning/hangranna/snabbkrok_mellan/snabbkrok_mellan.png",
        type: "hängränna",
      },
      {
        name: "Omvikningskupa",
        label: {
          sw: "Omvikningskupa",
          en: "Folding cup",
          nor: "Sammenleggbar kopp",
          da: "Foldekop",
          fin: "Taitettava kuppi",
          ru: "Складная чашка",
          gr: "Klappbecher"
        },
        contents: [],
        image:
          "vattenavrinning/hangranna/omvikningskupa/omvikningskupa_100.png",
        type: "hängränna",
      },
      {
        name: "Rännvinkel",
        label: {
          sw: "Rännvinkel",
          en: "Gutter angle",
          nor: "Rennevinkel",
          da: "Tagrendevinkel",
          fin: "Kourun kulma",
          ru: "Угол желоба",
          gr: "Dachrinnenwinkel"
        },
        contents: [],
        image: "vattenavrinning/hangranna/rannvinkel/rannvinkel_ytter_90.png",
        type: "hängränna",
      },
      {
        name: "Ränngavel",
        label: {
          sw: "Ränngavel",
          en: "Gutter end",
          nor: "Rennestein",
          da: "Rendeenden",
          fin: "Kourun pää",
          ru: "Конец желоба",
          gr: "Dachrinnenende"
        },
        contents: [],
        image: "vattenavrinning/hangranna/unigavel/unigavel.png",
        type: "hängränna",
      },
      {
        name: "Övrigt",
        label: {
          sw: "Övrigt",
          en: "Other",
          nor: "Annen",
          da: "Andet",
          fin: "Muu",
          ru: "Другой",
          gr: "Sonstiges"
        },
        contents: [],
        image: "vattenavrinning/hangranna/overspolningsskydd/overspolningsskydd_rakt.png",
        type: "hängränna",
      },
    ],
  },
  // {
  //   name: "Taksäkerhet",
  //   label: {
  //     sw: "Taksäkerhet",
  //     en: "Roof safety",
  //     nor: "Taksikkerhet",
  //     da: "Tag sikkerhed",
  //     fin: "Katon turvallisuus",
  //     ru: "Безопасность крыши",
  //     gr: "Dachsicherheit"
  //   },
  //   contents: [],
  // },
  {
    name: "Infästning",
    label: {
      sw: "Infästning",
      en: "Attachment",
      nor: "Vedlegg",
      da: "Vedhæftet fil",
      fin: "Liite",
      ru: "Вложение",
      gr: "Anhang"
    },
    contents: [
      {
        name: "all",
        label: {
          sw: "all",
          en: "all",
          nor: "alle",
          da: "alle",
          fin: "kaikki",
          ru: "все",
          gr: "alle"
        },
        image: "icons_water_drainage/all.svg",
      },
      {
        name: "Skruvar",
        label: {
          sw: "Skruv",
          en: "Screw",
          nor: "Skru",
          da: "Skrue",
          fin: "Ruuvi",
          ru: "Винт",
          gr: "Schraube"
        },
        image: "attachment/skruv/fonsterblecksskruv/fonsterblecksskruv_2.png",
        contents: [
          {
            name: "Fönsterblecksskruv",
            label: {
              sw: "Fönsterblecksskruv",
              en: "Window plate screw",
              nor: "Vindusplateskrue",
              da: "Vinduespladeskrue",
              fin: "Lasilevyruuvi",
              ru: "Винт оконной планки",
              gr: "Fensterplattenschraube"
            },
            image: "attachment/skruv/fonsterblecksskruv/fonsterblecksskruv_2.png",
            contents: [],
          },
          {
            name: "Farmarskruv",
            label: {
              sw: "Farmarskruv",
              en: "Farmaskruv",
              nor: "Farmaskruv",
              da: "Farmaskruv",
              fin: "Farmaskruv",
              ru: "Фармаскрув",
              gr: "Farmaskruv"
            },
            image: "attachment/skruv/farmarskruv/farmarskruv_4,8x60_silver_1.png",
            contents: [],
          },
          {
            name: "Vindskiveskruv",
            label: {
              sw: "Vindskiveskruv",
              en: "Windscreen screw",
              nor: "Vinduskrue",
              da: "Forrude skrue",
              fin: "Tuulilasin ruuvi",
              ru: "Винт ветрового стекла",
              gr: "Windschutzscheibenschraube"
            },
            image: "attachment/skruv/vindskiveskruv/vindskiveskruv_borrspets.png",
            contents: [],
          },
          {
            name: "Rännkroksskruv",
            label: {
              sw: "Rännkroksskruv",
              en: "Gutter hook screw",
              nor: "Takrenneskrue",
              da: "Gutter krog skrue",
              fin: "Kourun koukun ruuvi",
              ru: "Винт крюка водостока",
              gr: "Dachrinnenhakenschraube"
            },
            image: "attachment/skruv/rannkroksskruv/rannkroksskruv_borrspets.png",
            contents: [],
          },
          {
            name: "Balkskruv",
            label: {
              sw: "Balkskruv",
              en: "Beam screw",
              nor: "Lysstråleskrue",
              da: "Lysstråleskrue",
              fin: "Valokeilan ruuvi",
              ru: "Винт светового луча",
              gr: "Lichtstrahlschraube"
            },
            image: "attachment/skruv/balkskruv/balkskruv_12mm.png",
            contents: [],
          },
          {
            name: "Glidklammerskruv",
            label: {
              sw: "Glidklammerskruv",
              en: "Beam screw",
              nor: "Lysstråleskrue",
              da: "Lysstråleskrue",
              fin: "Valokeilan ruuvi",
              ru: "Винт светового луча",
              gr: "Lichtstrahlschraube"
            },
            image: "attachment/skruv/glidklammerskruv/glidklammerskruv.png",
            contents: [],
          },
        ],
      },
      {
        name: "Klammer",
        label: {
          sw: "Klammer",
          en: "Staple",
          nor: "Stift",
          da: "Hæftning",
          fin: "Niitti",
          ru: "Скоба",
          gr: "Klammer"
        },
        image: "attachment/klammer/stal/glid_25mm_skruv.png",
        contents: [
          {
            name: "Fasta klammer",
            label: {
              sw: "Fasta Klammer",
              en: "Staple",
              nor: "Stift",
              da: "Hæftning",
              fin: "Niitti",
              ru: "Скоба",
              gr: "Klammer"
            },
            image: "attachment/klammer/rostfri/rostfri_fast_32mm 2.png",
            contents: [],
          },
          {
            name: "Glidklammer",
            label: {
              sw: "Glidklammer",
              en: "Staple",
              nor: "Stift",
              da: "Hæftning",
              fin: "Niitti",
              ru: "Скоба",
              gr: "Klammer"
            },
            image: "attachment/klammer/rostfri/rostfri_glid_32mm 2.png",
            contents: [],
          },
          {
            name: "Tillbehör",
            label: {
              sw: "Tillbehör",
              en: "Accessories",
              nor: "Stift",
              da: "Hæftning",
              fin: "Niitti",
              ru: "Скоба",
              gr: "Klammer"
            },
            image: "attachment/klammer/tillbehor/bricka_till_krabban.png",
            contents: [],
          },
        ],
      },
      {
        name: "Blindnit",
        label: {
          sw: "Blindnit",
          en: "Popnit",
          nor: "Popnit",
          da: "Popnit",
          fin: "Popnit",
          ru: "Попнит",
          gr: "Popnit"
        },
        image: "attachment/blindnit/blindnit_3,2x8.png",
        contents: [
          {
            name: "Blindnit",
            label: {
              sw: "Blindnit",
              en: "Popnit",
              nor: "Popnit",
              da: "Popnit",
              fin: "Popnit",
              ru: "Попнит",
              gr: "Popnit"
            },
            image: "attachment/blindnit/blindnit_3,2x8.png",
            contents: [],
          },
          {
            name: "Blindnit trycktät",
            label: {
              sw: "Blindnit",
              en: "Popnit",
              nor: "Popnit",
              da: "Popnit",
              fin: "Popnit",
              ru: "Попнит",
              gr: "Popnit"
            },
            image: "attachment/blindnit/blindnit_trycktat_4,8x10.png",
            contents: [],
          },
        ],
      },
      {
        name: "Plugg",
        label: {
          sw: "Plugg",
          en: "Plug",
          nor: "Støpsel",
          da: "Prop",
          fin: "Pistoke",
          ru: "Затыкать",
          gr: "Stecker"
        },
        image: "attachment/plugg/nylonplugg_6x30.png",
        contents: [],
      },
      {
        name: "Spikplugg",
        label: {
          sw: "Spikplugg",
          en: "Nail plug",
          nor: "Spikerplugg",
          da: "Neglestik",
          fin: "Naulatulppa",
          ru: "Пробка для ногтей",
          gr: "Nageldübel"
        },
        image: "attachment/spikplugg/spikplugg.png",
        contents: [],
      },
    ],
  },
  {
    name: "Övrigt",
    label: {
      sw: "Övrigt",
      en: "Other",
      nor: "Annen",
      da: "Andet",
      fin: "Muu",
      ru: "Другой",
      gr: "Sonstiges"
    },
    contents: [
      {
        name: "all",
        label: {
          sw: "all",
          en: "all",
          nor: "alle",
          da: "alle",
          fin: "kaikki",
          ru: "все",
          gr: "alle"
        },
        image: "icons_water_drainage/all.svg",
      },
      {
        name: "Fogmassa",
        label: {
          sw: "Fogmassa",
          en: "Sealant",
          nor: "Tetningsmasse",
          da: "Tætningsmiddel",
          fin: "Tiivisteaine",
          ru: "Герметик",
          gr: "Dichtmittel"
        },
        image: "ovrigt/fog/runotex.png",
        contents: [],
      },
      {
        name: "Bättringsfärg",
        label: {
          sw: "Bättringsfärg",
          en: "Improvement paint",
          nor: "Forbedringsmaling",
          da: "Forbedringsmaling",
          fin: "Parannusmaali",
          ru: "Краска для улучшения",
          gr: "Verbesserungsfarbe"
        },
        image: "ovrigt/battringsfarg/battringsfarg.png",
        contents: [],
      },
      {
        name: "Underlagspapp",
        label: {
          sw: "Underlagspapp",
          en: "Paperboard",
          nor: "Papp",
          da: "Pap",
          fin: "Kartonki",
          ru: "Картон",
          gr: "Karton"
        },
        image: "ovrigt/underlagspapp/yep_2500.png",
        contents: [],
      },
      {
        name: "Skorstenstätning",
        label: {
          sw: "Skorstenstätning",
          en: "Waxaflex",
          nor: "Waxaflex",
          da: "Waxaflex",
          fin: "Waxaflex",
          ru: "Waxaflex",
          gr: "Waxaflex"
        },
        image: "ovrigt/skorstenstatning/skorstenstatning_rod.png",
        contents: [],
      },
    ],
  },
  
];

